import script from "./BarGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./BarGraph.vue?vue&type=script&setup=true&lang=js"

import "./BarGraph.vue?vue&type=style&index=0&id=1777a3b4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1777a3b4"]])

export default __exports__